import { render, staticRenderFns } from "./changerPassword.vue?vue&type=template&id=44f97924&scoped=true"
import script from "./changerPassword.vue?vue&type=script&lang=js"
export * from "./changerPassword.vue?vue&type=script&lang=js"
import style0 from "./changerPassword.vue?vue&type=style&index=0&id=44f97924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f97924",
  null
  
)

export default component.exports